import { useCallback, useState } from 'react';
import { useAuth } from '../../../contexts/authContext';
/** List ↔ map choice, remembered per user in localStorage (list is the default). */ export function useLandscapeView() {
    const { user } = useAuth();
    const key = `landscapes:view:${user?.tenant_id ?? ''}:${user?.id ?? ''}`;
    const [view, setView] = useState(()=>{
        try {
            return localStorage.getItem(key) === 'map' ? 'map' : 'list';
        } catch  {
            return 'list';
        }
    });
    const choose = useCallback((next)=>{
        setView(next);
        try {
            localStorage.setItem(key, next);
        } catch  {
        // Storage unavailable: the choice lasts for this page only.
        }
    }, [
        key
    ]);
    return [
        view,
        choose
    ];
}
